import { makeStyles } from "@material-ui/core";
import * as React from "react";
import { Datagrid, TextField, useListContext } from "react-admin";
import CustomLinearProgress from "../../../Components/Progress/LinearProgress";
import { CustomDateField } from "../../../Components/CustomDateField";
import DataGridActions from "../DataGridActions";
const useListStyles = makeStyles({
  headerCell: {
    backgroundColor: "#cc0000",
    color: "#fffafa",
  },
});
export const SubListGridColumns = props => {
  const listContext = useListContext();
  const classes = useListStyles();
  const { ids, filterValues, loading, data } = listContext;
  return loading ? (
    <CustomLinearProgress loading={loading} periodTime={300} />
  ) : (
    <Datagrid
      {...props}
      optimized
      hasBulkActions={false}
      classes={{
        headerCell: classes.headerCell,
      }}
    >
      <DataGridActions label="Actions" remarkAddClick={props.remarkAddClick} handlePDFViewer={props.handlePDFViewer} />
      <TextField source="customer" label="Customer" />
      <TextField source="pn" label="PN" />
      <TextField source="sn" label="SN" />
      <TextField source="pnDescription" label="PN Description" />
      <TextField source="site" label="Site" />
      <CustomDateField source="scheduleStartDate" label="Schedule Start Date" />
      <TextField source="wo" label="Wo" />
      <TextField source="woStatus" label="WO Status" />
      <TextField source="roNumber" label="RO" />
      <TextField source="roStatus" label="RO Status" />
      <CustomDateField source="lastDateReceived" label="Ro Closed Date" />
      <TextField source="pnCondition" label="PN Condition" />
      <TextField source="faultConfirm" label="Fault Confirm" />
      <TextField source="hardTime" label="Hard Time" />
      <TextField source="scrap" label="Scrap" />
      <TextField source="relationCode" label="Vendor Code" />
    </Datagrid>
  );
};

export default SubListGridColumns;
